<template>
    <li class="col-span-1 bg-white border border-gray-200 rounded-lg shadow divide-y divide-gray-200">
        <div class="w-full flex items-center justify-between p-6 space-x-6">
            <div class="flex-1 truncate">
                <h2 class="text-md tracking-widest uppercase font-bold text-gray-700">Latest Subscription</h2>
                <div class="flex items-center space-x-3">
                    <h3 class="text-gray-900 text-lg font-medium truncate">{{ subscription.package.name }}</h3>
                </div>
                <p class="mt-1 text-gray-500 text-sm truncate" v-if="subscription">
                    <template v-if="subscription.auto_renew">Renews on: {{ formatDateShort(subscription.expires) }}</template>
                    <template v-if="!subscription.auto_renew">Ends on: {{ formatDateShort(subscription.expires) }}</template>
                </p>
            </div>
        </div>
        <div>
            <div class="-mt-px flex divide-x divide-gray-200">
                <div class="w-0 flex-1 flex">
                    <a href="#" @click.prevent="showEnablements" class="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500">
                        <MagnifyingGlassCircleIcon class="w-5 h-5 text-gray-400" aria-hidden="true" />
                        <span class="ml-3">View Enablements</span>
                    </a>
                </div>
                <div class="-ml-px w-0 flex-1 flex">

                </div>
            </div>
        </div>
    </li>
</template>

<script>
import { toRef } from "vue"
import { MagnifyingGlassCircleIcon } from "@heroicons/vue/24/outline"

export default {
    name: "InvoiceSubscriptionBlock",
    components: {
        MagnifyingGlassCircleIcon,
    },
    props: {
        subscription: {
            type: Object,
            required: true,
        }
    },
    setup(props, context) {
        const subscription = toRef(props, 'subscription')

        const showEnablements = () => {
            context.emit('viewEnablements', subscription);
        }

        return {
            subscription,
            showEnablements,
        }
    }
}
</script>

<style scoped>

</style>
